import { render } from "./QuiSommeNous.vue?vue&type=template&id=2dea8142&scoped=true"
import script from "./QuiSommeNous.vue?vue&type=script&lang=js"
export * from "./QuiSommeNous.vue?vue&type=script&lang=js"

import "./QuiSommeNous.vue?vue&type=style&index=0&id=2dea8142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dea8142"]])

export default __exports__